import React from "react";
import "./Order_details_table.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Table } from "react-bootstrap";
import { OrderStatusIds, variant_type } from "../../../../../utils/common";

function Order_details_table({
  order,
  dontShowPrice,
  productId,
  setProductId,
  setShowReviewRating,
  showReviewRating,
}) {
  const handleOpenReview = async (productDetail) => {
    await setProductId(productDetail?.product_id);
    await setShowReviewRating(true);
  };
  return (
    <>
      {order?.Product_Order_Details?.map((product) => (
        <div className="product_content_holder">
          <div className="product_content">
            <div className="product_detail_inner">
              <div className="left_side">
                <div className="img_holder">
                  <img
                    src={
                      process.env.REACT_APP_IMG_URL + product?.Product?.image
                    }
                  />
                </div>

                <div className="text_holder">
                  <div className="product_name">
                    <p>{product?.Product?.name}</p>
                  </div>

                  {/* <p className="sub_text">
                    Mattress Size: 182.9x76.2 cm/72x30 in{" "}
                  </p>
                  <p className="sub_text"> Thickness: 22.86 cm/9 in</p> */}

                  <h6>
                    {product?.Product?.variant_type_id ===
                      variant_type.Single && (
                      <>
                        <strong>Mattress Size:</strong>{" "}
                        {product?.Product_Variant?.Metal?.name}
                      </>
                    )}

                    {product?.Product?.variant_type_id ===
                      variant_type.Double && (
                      <>
                        <strong>Mattress Size:</strong>{" "}
                        {product?.Double_Variant?.Product_Variant?.Metal?.name},{" "}
                        <strong>Thickness:</strong>{" "}
                        {product?.Double_Variant?.Size?.name}{" "}
                      </>
                    )}

                    {product?.Product?.variant_type_id ===
                      variant_type.Triple && (
                      <>
                        <p className="sub_text">
                          <strong>Mattress Size:</strong>{" "}
                          {
                            product?.Triple_Variant?.Double_Variant
                              ?.Product_Variant?.Metal?.name
                          }
                          ,{product?.Triple_Variant?.Double_Variant?.Size?.name}
                          ,{" "}
                        </p>
                        <p className="sub_text">
                          <strong>Thickness:</strong>{" "}
                          {product?.Triple_Variant?.Diamond?.name}
                        </p>
                      </>
                    )}
                  </h6>
                </div>
              </div>

              <div>
                <div className="qty_holder">
                  <p>
                    Quantity: {product?.quantity}{" "}
                    {!dontShowPrice && (
                      <div className="price">
                        ₹ {(Number(product?.selling_price)+Number(product?.total_tax)).toFixed(2)}
                      </div>
                    )}
                  </p>
                </div>
              </div>
            </div>

            {Number(order?.order_status_id) === OrderStatusIds.Delivered &&
              order?.Rating_Review === null && (
                <div className="mt-2">
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() => handleOpenReview(product)}
                  >
                    Review & Rating
                  </button>
                </div>
              )}
          </div>
        </div>
      ))}
      {/* <div className='product_content_holder'>
        <div className='product_content'>
          <div className='product_detail_inner'>
            <div className='left_side'>
              <div className='img_holder'>
                <img
                  src={
                    process.env.REACT_APP_IMG_URL +
                    order?.Product_Order_Details?.Product?.image
                  }
                />
              </div>

              <div className='text_holder'>
                <div className='product_name'>
                  <p>{order?.Product_Order_Details?.Product_Variant?.name}</p>
                </div>
                <div className='weight'>
                  <p>{order?.total_kg}</p>
                </div>
              </div>
            </div>

            <div>
              <div className='qty_holder'>
                <p>x 1 {!dontShowPrice && <span className='price'>₹ 120</span>}</p>
              </div>
            </div>

          </div>

          <div className='product_detail_inner'>
            <div className='left_side'>
              <div className='img_holder'>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/products/img2.png"
                  }
                />
              </div>

              <div className='text_holder'>
                <div className='product_name'>
                  <p>Apple</p>
                </div>
                <div className='weight'>
                  <p>0.5kg</p>
                </div>
              </div>
            </div>

            <div>
              <div className='qty_holder'>
                <p>x 1 {!dontShowPrice && <span className='price'>₹ 120</span>}</p>
              </div>
            </div>

          </div>
        </div>
      </div> */}
    </>
  );
}

export default Order_details_table;
